/**
 * Panele giren kullanıcının düştüğü sayfa.
 *
 * ---------------------------------------------------------------------------
 * Neden kendi dosyası — `dash-nav.ts` içinde değil
 * ---------------------------------------------------------------------------
 * Bu sabiti `src/proxy.ts` de okuyor ve proxy her istekte çalışıyor.
 * `dash-nav.ts` yirmi küsur Remixicon bileşeni import ediyor; oradan almak,
 * bir ikon kütüphanesini her sayfa isteğinin sıcak yoluna sokmak olurdu.
 * Bu dosyanın hiç importu yok ve olmayacak.
 *
 * ---------------------------------------------------------------------------
 * Neden sabit — beş dosyaya elle yazmak yerine
 * ---------------------------------------------------------------------------
 * Aynı adres beş yerde geçiyor: proxy'nin "oturumu olan kullanıcıyı /login'den
 * çevir" dalı, giriş formunun varsayılanı, giriş formunun `?next` doğrulaması,
 * kayıt formu ve sol menüdeki kelime işareti. Elle yazılsaydı açılış sayfası
 * bir gün değiştiğinde biri güncellenmeden kalır ve kullanıcı bazen bir yere,
 * bazen başka bir yere düşerdi — teşhisi zor, çünkü çoğu yol doğru çalışıyor
 * olurdu.
 *
 * ⚠️ Dil öneki YOK. Öneki `@/i18n/navigation`'daki `Link`/`useRouter` ekliyor;
 * proxy ise kendi `locale` değişkenini başa koyuyor.
 */
export const DASH_HOME = '/dashboard/agent';
